import axios from 'axios';

class AdminStatsService {
  getStatsTagsOverTimeByNumOfDays(metricPrefix, days = 3) {
    return axios.get(`/api/admin-stats/tags-overtime-counts?metricPrefix=${metricPrefix}&days=${days}`).then(res => res.data);
  }

  getAvailablePostArticles() {
    return axios.get(`/api/admin-stats/tags-avilable-post-articles`).then(res => res.data);
  }  

  getAvailableTweetArticles() {
    return axios.get(`/api/admin-stats/tags-avilable-tweet-articles`).then(res => res.data);
  }

  getStatsOverTimeByNumOfDays(metricPrefix, days = 3) {
    return axios.get(`/api/admin-stats/overtime-counts?metricPrefix=${metricPrefix}&days=${days}`).then(res => res.data);
  }

  getInstagramTotals1() {
    return axios.get(`/api/admin-stats/instagram-totals1`).then(res => res.data);
  }

  getInstagramTotals2() {
    return axios.get(`/api/admin-stats/instagram-totals2`).then(res => res.data);
  }  

  getInfluencersConversionDistribution(beforeXDays, untilXDays) {
    return axios.get(`/api/admin-stats/influencers-conversion-distribution?beforeXDays=${beforeXDays}&untilXDays=${untilXDays}`).then(res => res.data);
  }
}

const adminStatsService = new AdminStatsService();
export default adminStatsService;